// 维修看板
export const WorkingBoardRoutes = [{
  path: '/board',
  component: () => import('@pages/working-board/index'),
}]
